// @flow
import type { LoadingStatusStateType } from './reducer';

export type LoadingStatusActionType =
  | {|
      type: 'SET_LOADING',
      payload: {|
        page: $Keys<LoadingStatusStateType>,
        isLoading: boolean,
      |},
    |}
  | {|
      type: 'SET_ERROR',
      payload: {|
        page: $Keys<LoadingStatusStateType>,
        error: *,
      |},
      error: boolean,
    |};

export function setLoading(page: $Keys<LoadingStatusStateType>, isLoading: boolean): LoadingStatusActionType {
  return { type: 'SET_LOADING', payload: { page, isLoading } };
}

export function setError(page: $Keys<LoadingStatusStateType>, error: *): LoadingStatusActionType {
  return { type: 'SET_ERROR', payload: { page, error }, error: true };
}
